import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { token, user } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    fetch(`${API}/payments/verify-session?session_id=${sessionId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.user) {
          const updated = { ...user, ...data.user };
          localStorage.setItem("rira_user", JSON.stringify(updated));
          window.location.href = "/dashboard";
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <div className="auth-brand">
          <h1>R I R A</h1>
        </div>
        {status === "verifying" && (
          <>
            <div className="auth-spinner" style={{ margin: "24px auto" }} />
            <p style={{ color: "#6b7280" }}>Verifying your payment...</p>
          </>
        )}
        {status === "error" && (
          <>
            <p style={{ color: "#dc2626", marginBottom: 16 }}>
              Could not verify your payment. If you were charged, please contact support.
            </p>
            <button className="auth-submit" onClick={() => navigate("/dashboard")}>
              Go to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default PaymentSuccessPage;
